export function formatUSD(n: number): string {
  return '$' + n.toFixed(2).replace(/\.?0+$/, '');
}

export function formatDate(iso: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
}

function formatDayMonth(iso: string): string {
  if (!iso) return '—';
  return new Date(iso).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: '2-digit',
  });
}

// 19d.6: Payments are now weekly (Mon–Sun). Show them as
// "Semana del DD/MM al DD/MM" in both the admin kanban and the
// collector history list.
export function formatPeriod(start: string, end: string): string {
  if (!start || !end) return '—';
  return `Semana del ${formatDayMonth(start)} al ${formatDayMonth(end)}`;
}
